import sum from './sum';

const average = numbers => {
  return sum(numbers) / numbers.length;
};

export default average;
